export const getSpaceRepositoryLink =
  (projectKey, repositoryName) =>
    `https://jetbrains.team/p/${projectKey.toLowerCase()}/repositories/${repositoryName.toLowerCase()}`
